import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  IconButton,
  TextField,
  Box,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import DeleteIcon from "@mui/icons-material/Delete";
import { uploadMultipleShiftFiles } from "./../Redux/actionCreator";
import { toast } from "react-toastify";
import VisibilityIcon from "@mui/icons-material/Visibility";

const UploadProofModal = ({
  open,
  onClose,
  type,
  pendingTime,
  setValue,
  shiftId,
  jobCode,
  setProofUploaded,
  setProofUploadedCheckout,
  proofModal,
  responseData,
  isInvalidTime,
  setIsInvalidTime,
  setProofData,
  getValues,
}) => {

 const dispatch = useDispatch();
  const [files, setFiles] = useState([]);
  const [previewFile, setPreviewFile] = useState(null);
  const [remarks, setRemarks] = useState("");
  const [loading, setLoading] = useState(false);

  const handleCancel = () => {
    setFiles([]);
     setRemarks("");
     if (pendingTime) {
       setValue(
         `shiftLogs[${pendingTime.index}].${pendingTime.field}.datetime`,
         null
       );
     }
    onClose();
  };

  const MAX_FILE_SIZE = 5 * 1024 * 1024;
  const MAX_FILES = 10;
const handleFileChange = (e) => {
  const selectedFiles = Array.from(e.target.files);

  if (files.length + selectedFiles.length > MAX_FILES) {
    toast.error("You can upload maximum 10 files only");
    return;
  }

  const validFiles = [];
  for (let file of selectedFiles) {
    if (file.size > MAX_FILE_SIZE) {
      toast.error(`File "${file.name}" exceeds 5MB limit`);
    } else {
      validFiles.push(file);
    }
  }

  // ✅ Add only valid files
  setFiles((prev) => [...validFiles, ...prev]);
};  // const handleFileChange = (e) => {
  //   const selectedFiles = Array.from(e.target.files);
  //   setFiles((prev) => [...selectedFiles, ...prev]);
  // };

  const handleRemoveFile = (index) => {
    setFiles((prev) => prev.filter((_, i) => i !== index));
  };

  // console.log("inside upload", responseData);

  // const handleSubmit = () => {
  //   if (!remarks.trim()) {
  //     toast.error("Remarks is required");
  //     return;
  //   }

  //   if (!files.length && isInvalidTime) {
  //     toast.error("Please upload at least one proof");
  //     return;
  //   }

  //   // ✅ store proof in parent (NO API CALL)
  //   setProofData((prev) => ({
  //     ...prev,
  //     [shiftId]: {
  //       files,
  //       remarks,
  //       type,
  //     },
  //   }));

  //   setProofUploaded(true);
  //   setIsInvalidTime(false);
  //   setFiles([]);
  //   setRemarks("");
  //   onClose();
  // };
  const handleSubmit = async () => {
    if (!remarks.trim()) {
      toast.error("Remarks is required");
      return;
    }

    // if (!files.length && isInvalidTime === true) {
    //   toast.error("Please upload at least one proof");
    //   return;
    // }

    if (!shiftId || !jobCode) {
      toast.error("Shift ID or Job Code not found");
      return;
    }

    if (!pendingTime && isInvalidTime === true) return;


    try {
      setLoading(true);

      const payload = {
        files,
        jobId: jobCode,
        shiftId,
        type,
        remarks,
      };

      // console.log("payload", payload);

      const res = await dispatch(uploadMultipleShiftFiles(payload));
      // console.log("ttpe in upload docs",type)
      if (res?.payload?.status === true) {
        toast.success("Added Successfully");
        if (type === "CHECKIN"){
          setProofUploaded(true);
        }else{
           setProofUploadedCheckout(true);
        }
        setIsInvalidTime(false);
        setFiles([]);
        onClose();
      }
    } catch (err) {
      console.error(err);
      toast.error("Something went wrong");
    } finally {
      setLoading(false);
    }
  };
 

  useEffect(() => {
  return () => {
    files.forEach((file) => URL.revokeObjectURL(file));
  };
}, [files]);

  const existingProofs =
    responseData?.shiftLogs?.find((s) => s._id === shiftId)?.uploadProof?.[
      type === "CHECKIN" ? "checkIN" : "checkOut"
    ] || [];

  return (
    <Dialog
      open={open}
      onClose={(event, reason) => {
        if (reason === "backdropClick" || reason === "escapeKeyDown") {
          return;
        }
        handleCancel();
      }}
      maxWidth="sm"
      fullWidth
    >
      {isInvalidTime === false ? (
        <>
          <Box
            sx={{
              mt: 2,
              maxWidth: 550, // 👈 width control
              mx: "auto", // 👈 center align
              width: "100%",
            }}
          >
            <Typography
              variant="subtitle2"
              sx={{ mb: 1, fontWeight: 600, color: "#001f3f" }}
            >
              Remarks <span style={{ color: "red" }}>*</span>
            </Typography>

            <TextField
              fullWidth
              placeholder="Explain why you're uploading this proof (e.g. late check-in due to traffic...)"
              value={remarks}
              onChange={(e) => {
                if (e.target.value.length <= 1000) {
                  setRemarks(e.target.value);
                }
              }}
              multiline
              rows={3}
              variant="outlined"
              InputProps={{
                sx: {
                  borderRadius: "10px",
                  backgroundColor: "#fafafa",
                },
              }}
            />

            {/* Helper + Character count */}
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                mt: 0.5,
              }}
            >
              <Typography variant="caption" color="text.secondary">
                Max 1000 characters
              </Typography>

              <Typography
                variant="caption"
                color={remarks.length > 980 ? "error" : "text.secondary"}
              >
                {remarks.length}/1000
              </Typography>
            </Box>
          </Box>
        </>
      ) : (
        <>
          <Box
            sx={{
              mt: 2,
              maxWidth: 550, // 👈 width control
              mx: "auto", // 👈 center align
              width: "100%",
            }}
          >
            <Typography
              variant="subtitle2"
              sx={{ mb: 1, fontWeight: 600, color: "#001f3f" }}
            >
              Remarks <span style={{ color: "red" }}>*</span>
            </Typography>

            <TextField
              fullWidth
              placeholder="Explain why you're uploading this proof (e.g. late check-in due to traffic...)"
              value={remarks}
              onChange={(e) => {
                if (e.target.value.length <= 1000) {
                  setRemarks(e.target.value);
                }
              }}
              multiline
              rows={3}
              variant="outlined"
              InputProps={{
                sx: {
                  borderRadius: "10px",
                  backgroundColor: "#fafafa",
                },
              }}
            />

            {/* Helper + Character count */}
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                mt: 0.5,
              }}
            >
              <Typography variant="caption" color="text.secondary">
                Max 1000 characters
              </Typography>

              <Typography
                variant="caption"
                color={remarks.length > 980 ? "error" : "text.secondary"}
              >
                {remarks.length}/1000
              </Typography>
            </Box>
          </Box>
          <DialogTitle>Upload Proof ({type})</DialogTitle>
          <DialogContent>
            <Typography sx={{ mb: 2 }}>
              Selected time is outside allowed window. Please upload proof(s).
            </Typography>

            {/* ✅ Add files button */}
            <Button
              variant="outlined"
              component="label"
              sx={{
                color: "#001f3f",
                borderColor: "#001f3f",
                "&:hover": {
                  borderColor: "#001f3f",
                  backgroundColor: "rgba(0, 31, 63, 0.04)",
                },
              }}
            >
              Add Files
              <input
                type="file"
                hidden
                multiple
                accept="image/*,.pdf"
                onChange={handleFileChange}
              />
            </Button>

            {/* ✅ File List */}
            {/* {files.length > 0 && (
          <div style={{ marginTop: 15 }}>
            <Typography variant="body2" sx={{ mb: 1 }}>
              Selected Files:
            </Typography>

            {files.map((file, idx) => (
              <div
                key={idx}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  fontSize: 13,
                  padding: "6px 8px",
                  border: "1px solid #eee",
                  borderRadius: 6,
                  marginBottom: 6,
                }}
              >
                <span>{file.name}</span>

                <IconButton size="small" onClick={() => handleRemoveFile(idx)}>
                  <DeleteIcon fontSize="small" />
                </IconButton>
              </div>
            ))}
          </div>
        )} */}
            {/* ✅ File List */}
            {(files.length > 0 || existingProofs.length > 0) && (
              <div style={{ marginTop: 15 }}>
                <Typography variant="body2" sx={{ mb: 1 }}>
                  Files:
                </Typography>

                {/* 🔥 New Files (TOP) */}
                {/* {files.map((file, idx) => (
              <div
                key={`new-${idx}`}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  fontSize: 13,
                  padding: "6px 8px",
                  border: "1px solid #d1e7dd",
                  borderRadius: 6,
                  marginBottom: 6,
                  background: "#f0fff4",
                }}
              >
                <span>🆕 {file.name}</span>

                <IconButton size="small" onClick={() => handleRemoveFile(idx)}>
                  <DeleteIcon fontSize="small" />
                </IconButton>
              </div>
            ))} */}
                {files.map((file, idx) => {
                  const fileUrl = URL.createObjectURL(file);

                  return (
                    <div
                      key={idx}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        fontSize: 13,
                        padding: "8px",
                        border: "1px solid #eee",
                        borderRadius: 6,
                        marginBottom: 8,
                      }}
                    >
                      <span>{file.name}</span>

                      <div style={{ display: "flex", gap: 5 }}>
                        {/* 👁️ Preview */}
                        <IconButton
                          size="small"
                          onClick={() =>
                            setPreviewFile({ url: fileUrl, type: file.type })
                          }
                        >
                          <VisibilityIcon fontSize="small" />
                        </IconButton>

                        {/* ❌ Remove */}
                        <IconButton
                          size="small"
                          onClick={() => handleRemoveFile(idx)}
                        >
                          <DeleteIcon fontSize="small" />
                        </IconButton>
                      </div>
                    </div>
                  );
                })}

                {/* 🔥 Existing Files */}
                {/* {existingProofs.map((file, idx) => (
                  <div
                    key={`existing-${idx}`}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      fontSize: 13,
                      padding: "6px 8px",
                      border: "1px solid #eee",
                      borderRadius: 6,
                      marginBottom: 6,
                    }}
                  >
                    <a href={file.file} target="_blank" rel="noreferrer">
                      📎 {file.file.split("/").pop()}
                    </a>
                  </div>
                ))} */}
                {existingProofs.map((file, idx) => (
                  <div
                    key={`existing-${idx}`}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      fontSize: 13,
                      padding: "8px",
                      border: "1px solid #e3f2fd",
                      borderRadius: 8,
                      marginBottom: 8,
                      background: "#f5faff",
                    }}
                  >
                    {/* 🔹 File Name */}
                    <span style={{ fontWeight: 500 }}>📄 File {idx + 1}</span>

                    {/* 🔹 Actions */}
                    <div style={{ display: "flex", gap: 6 }}>
                      {/* 👁️ View */}
                      <IconButton
                        size="small"
                        onClick={() =>
                          setPreviewFile({
                            url: file.file,
                            type: "existing",
                          })
                        }
                        sx={{
                          color: "#1976d2",
                          "&:hover": { backgroundColor: "#e3f2fd" },
                        }}
                      >
                        <VisibilityIcon fontSize="small" />
                      </IconButton>
                    </div>
                  </div>
                ))}

                <Dialog
                  open={!!previewFile}
                  onClose={() => setPreviewFile(null)}
                  maxWidth="md"
                  fullWidth
                >
                  <DialogTitle>Preview</DialogTitle>

                  <DialogContent>
                    {previewFile?.type?.includes("image") ||
                    previewFile?.type === "existing" ? (
                      <img
                        src={previewFile?.url}
                        alt="preview"
                        style={{ width: "100%", borderRadius: 8 }}
                      />
                    ) : (
                      <iframe
                        src={previewFile?.url}
                        title="preview"
                        width="100%"
                        height="500px"
                      />
                    )}
                  </DialogContent>

                  <DialogActions>
                    <Button onClick={() => setPreviewFile(null)}>Close</Button>
                  </DialogActions>
                </Dialog>
              </div>
            )}
          </DialogContent>
        </>
      )}

      <DialogActions>
        <Button onClick={handleCancel}>Cancel</Button>
        <Button variant="contained" onClick={handleSubmit} disabled={loading}>
          {/* Save */}
          {loading ? "Saving..." : "Save"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default UploadProofModal;
